/**
 * FFWheels — Specs as plain text (works with BUTTON / block variant picker)
 * Upload to: Assets → ffwheels-specs-filter.js  (replace the whole file)
 * theme.liquid keeps the same tag before </body>:
 *   <script src="{{ 'ffwheels-specs-filter.js' | asset_url }}" defer></script>
 *
 * How it works:
 * - Reads every variant from Shopify's own /products/<handle>.js (no DOM guessing)
 * - Hides the Specs buttons, shows every spec for the chosen Finish + Size as plain text
 * - Quietly selects a valid spec in the background so the right variant goes to cart
 * - If a size isn't offered in the chosen finish, jumps to the first size that is
 * - Re-draws itself whenever Prestige re-renders the variant picker
 */
(function () {
  'use strict';
  if (window.__ffwSpecsLoaded) return;
  window.__ffwSpecsLoaded = true;

  // ── CSS ──────────────────────────────────────────────────────────────
  var css = document.createElement('style');
  css.textContent =
    '.variant-picker__option:has([data-option-position="3"]) .variant-picker__option-values{display:none!important}' +
    '#ffw-specs-box{margin-top:8px;padding:12px 16px;background:rgba(0,0,0,.03);' +
    'border:1px solid rgba(0,0,0,.08);border-radius:6px;font-size:13px;line-height:1.8;color:#555}' +
    '#ffw-specs-box span{display:block}' +
    '.variant-picker__option:has([data-option-position="2"]) .variant-picker__option-values{display:flex;flex-wrap:wrap}';
  document.head.appendChild(css);

  var variants = null;

  // ── Helpers ──────────────────────────────────────────────────────────
  function clean(v) { return String(v == null ? '' : v).trim().replace(/\s+/g, ' '); }

  function specsField() {
    return document.querySelector('.variant-picker__option:has([data-option-position="3"])');
  }

  // Limit lookups to the main product's picker (ignores quick-buy drawers etc.)
  function scope() {
    var f = specsField();
    return (f && (f.closest('variant-picker') || f.closest('form') || f.parentElement)) || document;
  }

  // Real option values from the product, e.g. {1: ['Black Chrome', ...], 2: ['18"', ...]}
  var optionValues = { 1: [], 2: [], 3: [] };

  function norm(s) { return clean(s).replace(/\s+/g, ' '); }

  // Work out which real option value an input stands for.
  // Prestige may put an ID in input.value, so check the visible label too.
  function labelFor(input) {
    var lab = null;
    if (input.id) {
      try { lab = document.querySelector('label[for="' + CSS.escape(input.id) + '"]'); } catch (e) {}
    }
    return lab || input.closest('label');
  }

  function valueOf(input, pos) {
    var known = optionValues[pos];
    var cands = [input.value, input.getAttribute('data-value'), input.getAttribute('data-option-value')];
    var lab = labelFor(input);
    var labText = '';
    if (lab) {
      var span = lab.querySelector('span:not(.sr-only)');
      if (span) cands.push(span.textContent);
      labText = norm(lab.textContent);
      cands.push(labText);
    }
    // 1) exact match
    for (var i = 0; i < cands.length; i++) {
      var c = norm(cands[i]);
      if (c && known.indexOf(c) > -1) return c;
    }
    // 2) label contains the value (ignores extra hidden text) — longest wins,
    //    so "Black Chrome" beats "Chrome"
    var best = null;
    known.forEach(function (k) {
      if (labText.indexOf(k) > -1 && (!best || k.length > best.length)) best = k;
    });
    return best;
  }

  function checked(pos) {
    var i = scope().querySelector('input[data-option-position="' + pos + '"]:checked');
    return i ? valueOf(i, pos) : null;
  }

  function inputFor(pos, value) {
    var list = scope().querySelectorAll('input[data-option-position="' + pos + '"]');
    for (var i = 0; i < list.length; i++) {
      if (valueOf(list[i], pos) === value) return list[i];
    }
    return null;
  }

  function variantsFor(finish, size) {
    return variants.filter(function (v) {
      return clean(v.option1) === finish && clean(v.option2) === size;
    }).sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });
  }

  // ── Keep a real variant selected ─────────────────────────────────────
  // useClick=false → just tick the hidden inputs (no events), used BEFORE Prestige
  // reads the form so it loads the right variant in one go
  function choose(input, useClick) {
    if (!input || input.checked) return;
    if (useClick) input.click(); else input.checked = true;
  }

  function sync(useClick) {
    if (useClick === undefined) useClick = true;
    if (!variants || !specsField()) return;
    var finish = checked(1), size = checked(2);
    if (!finish) return;

    var list = variantsFor(finish, size);

    // Size not offered in this finish → pick the first size that is
    if (!list.length) {
      var first = variants.filter(function (v) { return clean(v.option1) === finish; })[0];
      if (!first) return;
      choose(inputFor(2, clean(first.option2)), useClick);
      if (useClick) return; // the click triggers another pass
      list = variantsFor(finish, clean(first.option2));
      if (!list.length) return;
    }

    // Make sure the hidden spec matches one that exists for this finish + size
    var current = checked(3);
    var ok = list.some(function (v) { return clean(v.option3) === current; });
    if (!ok) choose(inputFor(3, clean(list[0].option3)), useClick);
  }

  // ── Draw the plain-text specs list ───────────────────────────────────
  function render() {
    var field = specsField();
    if (!field || !variants) return;

    var finish = checked(1), size = checked(2);
    var seen = {}, lines = [];
    variantsFor(finish, size).forEach(function (v) {
      var s = clean(v.option3);
      if (s && !seen[s]) { seen[s] = 1; lines.push(s); }
    });

    var key = finish + '|' + size + '|' + lines.join('~');
    var box = field.querySelector('#ffw-specs-box');
    if (box && box.getAttribute('data-key') === key) return; // nothing changed

    if (!box) {
      box = document.createElement('div');
      box.id = 'ffw-specs-box';
      field.appendChild(box);
    }
    box.setAttribute('data-key', key);
    box.innerHTML = '';

    if (!lines.length) {
      var msg = document.createElement('span');
      msg.textContent = 'Choose a size to see specs.';
      box.appendChild(msg);
      return;
    }
    lines.forEach(function (t) {
      var line = document.createElement('span');
      line.textContent = t;
      box.appendChild(line);
    });
  }

  // ── Size buttons: hide sizes not offered in this finish, sort small → large ──
  function sizeNum(sz) { return parseFloat(String(sz).replace(/[^0-9.]/g, '')) || 0; }

  // Uses a <style> rule (not inline styles) so it survives Prestige redrawing the buttons
  var sizeStyle = null;
  function renderSizeButtons() {
    if (!variants) return;
    var field = document.querySelector('.variant-picker__option:has([data-option-position="2"])');
    if (!field) return;
    var finish = checked(1);
    var rules = [];

    field.querySelectorAll('input[data-option-position="2"]').forEach(function (inp) {
      var sz = valueOf(inp, 2);
      if (!sz) return;
      var ok = variants.some(function (v) { return clean(v.option1) === finish && clean(v.option2) === sz; });

      var sels = [];
      var raw = inp.getAttribute('value');
      if (raw != null) {
        var attr = 'input[data-option-position="2"][value="' + CSS.escape(raw) + '"]';
        sels.push('.variant-picker__option-values > :has(' + attr + ')');
        sels.push('.variant-picker__option-values > ' + attr);
      }
      if (inp.id) sels.push('label[for="' + CSS.escape(inp.id) + '"]');
      if (!sels.length) return;

      rules.push(sels.join(',') + '{order:' + Math.round(sizeNum(sz) * 10) +
                 (ok ? '' : ';display:none!important') + '}');
    });

    var css = rules.join('\n');
    if (!sizeStyle) {
      sizeStyle = document.createElement('style');
      sizeStyle.id = 'ffw-size-rules';
      document.head.appendChild(sizeStyle);
    }
    if (sizeStyle.textContent !== css) sizeStyle.textContent = css;
  }

  // ── Gallery image follows the finish ─────────────────────────────────
  var lastFinish = null;
  function switchImage() {
    var finish = checked(1);
    if (!finish || finish === lastFinish) return;
    lastFinish = finish;
    var fl = finish.toLowerCase(), match = null;
    document.querySelectorAll('[data-media-id]').forEach(function (slide) {
      if (match) return;
      var img = slide.querySelector('img');
      if (img && (img.alt || '').toLowerCase().indexOf(fl) > -1) match = slide;
    });
    if (match) match.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }

  // ── Scheduling ───────────────────────────────────────────────────────
  // Show the size row once it's sorted (head CSS keeps it invisible until then)
  function reveal() { document.documentElement.classList.add('ffw-sizes-ready'); }
  setTimeout(reveal, 1500); // safety net

  function runAll() {
    sync(); renderSizeButtons(); render(); switchImage();
    if (variants) reveal();
  }

  // Runs at most once per delay window; constant page changes from apps can't stall it
  var timer = null;
  function update(delay) {
    if (timer) return;
    timer = setTimeout(function () { timer = null; runAll(); }, delay);
  }

  // CAPTURE phase: runs before Prestige's own handler. We fix size + spec first,
  // so Prestige loads a real variant on the first try (no "Unavailable" / old price)
  // Listen on click + input + change so we run first no matter which one Prestige uses.
  // (By the time 'click' fires on a radio, the browser has already ticked it.)
  function preselect(e) {
    var t = e.target;
    if (!t || t.tagName !== 'INPUT' || !t.checked) return;
    var pos = t.getAttribute('data-option-position');
    if (pos === '1' || pos === '2') {
      sync(false);
      renderSizeButtons();
      render();
    }
  }
  ['click', 'input', 'change'].forEach(function (type) {
    document.addEventListener(type, preselect, true);
  });

  document.addEventListener('change', function (e) {
    var pos = e.target && e.target.getAttribute && e.target.getAttribute('data-option-position');
    if (pos === '1' || pos === '2') update(250); // backup pass
  });
  document.addEventListener('variant:change', function () { update(250); });

  // Prestige can swap out the whole picker after a click — redraw when it does
  // When Prestige redraws the picker, put the specs text back before the next paint
  var rafPending = false;
  new MutationObserver(function () {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(function () { rafPending = false; renderSizeButtons(); render(); });
    }
    update(150);
  })
    .observe(document.body, { childList: true, subtree: true });

  // ── Init: variants come inline from theme.liquid (instant); fetch as fallback ──
  function setVariants(list) {
    variants = list || [];
    variants.forEach(function (v) {
      [1, 2, 3].forEach(function (n) {
        var val = clean(v['option' + n]);
        if (val && optionValues[n].indexOf(val) === -1) optionValues[n].push(val);
      });
    });
    lastFinish = checked(1);
    runAll(); // draw immediately, no waiting
  }

  function init() {
    var inline = document.getElementById('ffw-product-variants');
    if (inline) {
      try { setVariants(JSON.parse(inline.textContent)); return; } catch (e) {}
    }
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) { reveal(); return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { setVariants(p.variants); })
      .catch(function (err) { console.warn('[FFW specs] could not load variants', err); reveal(); });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
